// Les textes du module, en français. Exactement les mêmes clés que es.js.

export default {
  markets: {
    title: 'Marchés',

    actions: {
      save: 'Enregistrer',
      saved: 'Enregistré',
      cancel: 'Annuler',
      edit: 'Modifier',
      remove: 'Retirer',
    },

    units: {
      points: 'pts',
    },

    windows: {
      day: 'Un jour',
      week: 'Une semaine',
      month: '30 jours',
      year: 'Un an',
    },

    home: {
      title: 'Marchés',
      subtitle: 'Ce qui change dehors, et ce que cela vous coûte',
      prepareMeeting: 'Préparer une réunion',
      risks: 'Risques ouverts',
      opportunities: 'Opportunités',
      watched: 'Facteurs surveillés',
      newReports: 'Nouveaux rapports',
      exposure: 'Achats exposés',
      costAtRisk: 'Surcoût annuel',
      whatChanged: 'Ce qui a changé',
      summarise: 'Résumer avec l\'IA',
      summaryUnavailable: 'Le résumé n\'est pas disponible pour le moment. Les changements ci-dessous restent les mêmes.',
      nothingChanged: 'Rien n\'a bougé',
      nothingChangedHint: 'Aucun facteur surveillé n\'a franchi son seuil depuis votre dernière visite.',
      references: '{count} références',
      radar: 'Ce qui bouge le plus',
      radarQuiet: 'Aucun facteur surveillé n\'est hors de sa plage habituelle.',
      unlinked: '{count} indicateurs ne sont reliés à rien de chez vous : ceux-là ne produisent aucun chiffre en euros.',
      stale: '{count} indicateurs n\'ont pas été mis à jour depuis un moment.',
      toDo: 'En attente de quelqu\'un',
      sourcesDue: 'Sources à revoir',
      decisionsDue: 'Décisions à évaluer',
      overdue: '{count} jours de retard',
      nothingToDo: 'Rien n\'est en attente.',
      reports: 'Rapports récents',
      kind: {
        impact: 'Impact',
        indicator: 'Indicateur',
        report: 'Rapport',
      },
    },

    coverage: {
      title: 'Pas encore de données internes',
      body: 'Ce module confronte ce qui se passe dehors à votre consommation, vos achats et vos coûts. Sans Stock ni Achats installés, il n\'y a rien à quoi le confronter.',
      hint: 'La partie extérieure — thèmes, sources, rapports et indicateurs — fonctionne dès aujourd\'hui.',
    },

    radar: {
      title: 'Radar',
      subtitle: 'Tout ce que vous surveillez, avec sa couleur',
      recompute: 'Recalculer maintenant',
      recomputed: 'Recalculé : {count} impacts',
      colFactor: 'Facteur',
      colValue: 'Valeur',
      colChange: 'Variation',
      colStatus: 'État',
      colCost: 'Coût annuel',
      noLinks: 'Non relié',
      notUpdated: 'Non mis à jour',
      unlinked: '{count} non reliés à quoi que ce soit de chez vous',
      stale: '{count} non mis à jour',
      empty: 'Le radar est vide',
      emptyHint: 'Créez un indicateur et collez sa série pour qu\'il commence à être surveillé.',
    },

    status: {
      favourable: 'Favorable',
      neutral: 'Normal',
      watch: 'Attention',
      risk: 'Risque',
      critical: 'Critique',
      unknown: 'Sans données',
      up: 'En hausse',
      down: 'En baisse',
      flat: 'Stable',
    },

    severity: {
      info: 'Information',
      watch: 'Attention',
      high: 'Important',
      critical: 'Critique',
    },

    direction: {
      risk: 'Risque',
      opportunity: 'Opportunité',
      both: 'Risques et opportunités',
    },

    trend: {
      up: 'À la hausse',
      down: 'À la baisse',
      flat: 'Stable',
      unknown: 'Série insuffisante',
    },

    kinds: {
      commodity: 'Matières premières',
      energy: 'Énergie',
      logistics: 'Transport et logistique',
      industry: 'Activité industrielle',
      construction: 'Construction',
      economy: 'Économie',
      fx: 'Devises',
      labour: 'Main-d\'œuvre',
      sector: 'Secteur',
    },

    valueTypes: {
      price: 'Prix',
      index: 'Indice',
      rate: 'Taux ou pourcentage',
      quantity: 'Quantité',
    },

    badDirection: {
      up: 'La hausse nous pénalise',
      down: 'La baisse nous pénalise',
      none: 'Aucune direction ne nous pénalise',
    },

    origins: {
      manual: 'À la main',
      import: 'Collé',
      report: 'D\'un rapport',
      feed: 'Automatique',
    },

    horizons: {
      short: 'Court terme',
      medium: 'Moyen terme',
      long: 'Long terme',
      unknown: 'Sans horizon',
    },

    importance: {
      1: 'Faible',
      2: 'Moyenne',
      3: 'Élevée',
    },

    strength: {
      none: 'nulle',
      weak: 'faible',
      moderate: 'modérée',
      strong: 'forte',
    },

    confidence: {
      high: 'Confiance élevée',
      medium: 'Confiance moyenne',
      low: 'Confiance faible',
      short: 'Confiance {score}',
    },

    metrics: {
      revenue: 'Chiffre d\'affaires',
      order_intake: 'Affaires gagnées',
      offers_out: 'Devis émis',
      purchase_spend: 'Achats reçus',
      material_cost: 'Matière consommée',
    },

    tiers: {
      A: 'Organisme officiel : institut statistique, Eurostat, BCE, Commission européenne',
      B: 'Fédération professionnelle ou cabinet reconnu',
      C: 'Presse spécialisée',
      D: 'Non vérifiée',
    },

    sourceKinds: {
      website: 'Site web',
      rss: 'RSS',
      pdf: 'PDF',
      report: 'Rapport',
      api: 'API',
      spreadsheet: 'Tableur',
      newsletter: 'Lettre d\'information',
      association: 'Fédération professionnelle',
      public_body: 'Organisme public',
      supplier: 'Fournisseur',
      institute: 'Institut économique',
      bank: 'Banque',
      consultancy: 'Cabinet de conseil',
      manual: 'À la main',
    },

    indicators: {
      title: 'Indicateurs',
      subtitle: 'Ce que vous surveillez dehors, avec sa série',
      new: 'Nouvel indicateur',
      edit: 'Modifier l\'indicateur',
      searchPlaceholder: 'Nom ou clé…',
      allKinds: 'Toutes les catégories',
      colName: 'Indicateur',
      colValue: 'Dernière valeur',
      colMonth: '30 jours',
      colYear: 'Un an',
      colLinks: 'Relié',
      linked: '{count} liens',
      unlinked: 'Non relié',
      empty: 'Pas encore d\'indicateurs',
      emptyCommodities: 'Pas encore de matières premières',
      emptyHint: 'Créez le premier et collez sa série de prix ; tout le reste en découle.',
      name: 'Nom',
      namePlaceholder: 'Acier laminé (Europe)',
      kind: 'Catégorie',
      valueType: 'Ce qu\'est la valeur',
      valueTypeHint: 'Un prix se lit en pourcentage ; un taux comme l\'inflation se lit en points.',
      unit: 'Unité',
      unitHint: 'Ce qui suit le nombre.',
      unitPlaceholder: 'EUR/kg',
      source: 'Source',
      noSource: 'Sans source',
      badDirection: 'Quelle direction vous pénalise',
      badDirectionHint: 'Que l\'acier monte pénalise un fabricant ; que l\'électricité baisse l\'avantage. Sans cela, le radar colore à l\'envers.',
      watchThreshold: 'Seuil d\'attention (%)',
      alertThreshold: 'Seuil de risque (%)',
      thresholdHint: 'Sur 30 jours. Vide utilise celui du module.',
      default: 'Par défaut',
      description: 'Description',
    },

    commodities: {
      title: 'Matières premières',
      subtitle: 'Ce que vous achetez, et de combien son prix bouge',
    },

    indicator: {
      subtitle: '{kind} · mis à jour {updated}',
      current: 'Maintenant',
      trend: 'Tendance',
      series: 'Série',
      from: '{source} · niveau {tier}',
      noSeries: 'Pas encore assez de relevés pour tracer quoi que ce soit.',
      addReading: 'Ajouter un relevé',
      links: 'Liens',
      simulate: 'Simuler',
      linkedTo: 'Ce qu\'il touche',
      noLinks: 'Relié à rien de chez vous',
      noLinksHint: 'Sans liens cet indicateur est une information, pas des euros. Reliez-le aux références qui en dépendent.',
      readings: 'Relevés',
      noReadings: 'Pas encore de relevés',
      noReadingsHint: 'Ajoutez-en un à la main, ou collez la série entière depuis un tableur.',
      colDate: 'Date',
      colValue: 'Valeur',
      colOrigin: 'D\'où cela vient',
      fromReport: 'Ouvrir le rapport',
      removeReading: 'Retirer ce relevé ?',
      removeReadingHint: 'La série est recalculée sans lui. La trace reste dans l\'audit.',
    },

    points: {
      title: 'Relevés de {name}',
      tabOne: 'Un relevé',
      tabMany: 'Coller une série',
      date: 'Date',
      value: 'Valeur {unit}',
      valuePlaceholder: '1,29',
      note: 'Note',
      noteHint: 'D\'où sort ce chiffre précis, si ce n\'est pas la source habituelle.',
      save: 'Enregistrer le relevé',
      saved: 'Relevé enregistré',
      paste: 'Collez deux colonnes : date et valeur',
      pasteHint: 'Telles qu\'elles sortent du tableur ou de la page. Les deux séparateurs décimaux et les deux formats de date sont compris.',
      pastePlaceholder: '01/01/2026;1,18\n01/02/2026;1,21',
      import: 'Importer',
      imported: '{count} relevés enregistrés',
      rejected: '{count} lignes n\'ont pas pu être lues',
      line: 'Ligne {line}',
      reason: {
        columns: 'n\'a pas deux colonnes',
        date: 'la date est incompréhensible',
        value: 'la valeur est incompréhensible',
      },
    },

    links: {
      title: 'Liens de {name}',
      lead: 'Un lien dit quelle part du coût d\'une référence cet indicateur explique. Sans liens, aucun chiffre en euros nulle part.',
      tabCurrent: 'Actuels',
      tabAdd: 'Ajouter',
      tabSuggest: 'Proposer avec l\'IA',
      none: 'Pas encore de liens',
      noneHint: 'Reliez cet indicateur aux références ou aux familles qui en dépendent.',
      colTarget: 'Ce qu\'il touche',
      colWeight: 'Part',
      colOrigin: 'État',
      colReason: 'Pourquoi',
      confirmed: 'Confirmé',
      proposed: 'Proposé',
      confirm: 'Confirmer',
      remove: 'Retirer',
      what: 'Ce qu\'on relie',
      material: 'Référence',
      materialPlaceholder: 'Cherchez par nom ou par code…',
      category: 'Famille',
      metric: 'Chiffre interne',
      metricHint: 'Pour comparer le marché à votre propre évolution.',
      supplierId: 'Identifiant du fournisseur',
      supplierHint: 'Pour pouvoir comparer ce fournisseur à cet indice.',
      weight: 'Part (0 à 1)',
      weightHint: 'Quelle part du coût de cette référence cet indicateur explique. Un profilé acier, 0,9 ; une vanne finie, 0,3.',
      add: 'Ajouter le lien',
      suggestLead: 'L\'IA propose ; rien n\'est écrit tant que vous n\'acceptez pas. Ce qui est accepté reste non confirmé jusqu\'à ce que vous le repassiez un par un.',
      searchPlaceholder: 'Restreignez le catalogue : acier, tube, profilé…',
      suggest: 'Proposer',
      suggestUnavailable: 'Les propositions ne sont pas disponibles sur cette instance. Les liens peuvent être ajoutés à la main.',
      acceptNote: 'Ce que vous acceptez est enregistré comme proposition. L\'exposition dira combien de liens restent non confirmés.',
      accept: 'Accepter {count}',
      accepted: '{count} liens créés',
      target: {
        material: 'Référence',
        category: 'Famille',
        metric: 'Chiffre interne',
        supplier: 'Fournisseur',
      },
    },

    impacts: {
      title: 'Impacts',
      subtitle: 'Ce qui a bougé dehors, mesuré contre le vôtre',
      recompute: 'Recalculer',
      recomputed: 'Recalculé : {count} impacts',
      status: 'Statut',
      direction: 'Sens',
      risks: 'Risques',
      opportunities: 'Opportunités',
      exposure: 'Achats exposés',
      costAtRisk: 'Surcoût annuel',
      savings: 'Économie annuelle',
      colWhat: 'Ce qui a bougé',
      colChange: 'Variation',
      colCost: 'Par an',
      colReferences: 'Références',
      colSeverity: 'Gravité',
      colConfidence: 'Confiance',
      overDays: 'sur {count} jours',
      empty: 'Aucun impact ouvert',
      emptyHint: 'Rien de ce que vous surveillez n\'a bougé assez pour coûter de l\'argent.',
    },

    impactStatus: {
      open: 'Ouverts',
      reviewed: 'Revus',
      decided: 'Décidés',
      dismissed: 'Écartés',
      expired: 'Retombés',
      all: 'Tous',
    },

    impact: {
      subtitle: '{change} sur {days} jours',
      explain: 'Expliquer avec l\'IA',
      explainUnavailable: 'L\'explication n\'est pas disponible pour le moment. Les chiffres ci-dessus ne changent pas.',
      dismiss: 'Écarter',
      dismissConfirm: 'Écarter cet impact ?',
      dismissConfirmHint: 'Il cesse de compter dans le tableau. Le chiffre et sa trace restent, au cas où.',
      decide: 'Enregistrer une décision',
      references: 'Les références derrière le chiffre',
      colReference: 'Référence',
      colShare: 'Part',
      colSpend: 'Achats annuels',
      colDelta: 'Différence',
      decisions: 'Décisions prises',
      evidence: 'D\'où cela sort',
      state: 'État',
      status: 'Situation',
      raised: 'Détecté',
      reviewed: 'Revu',
      dismissReason: 'Motif',
      openIndicator: 'Ouvrir l\'indicateur',
    },

    insight: {
      what: 'Ce qui s\'est passé',
      why: 'Pourquoi cela compte',
      action: 'Ce qu\'on peut faire',
      overDays: 'sur {count} jours',
      touches: 'Touche {count} de vos références',
      suppliers: '· {count} fournisseurs',
      exposure: 'Achats annuels exposés',
      annualCost: 'Effet sur l\'année',
    },

    evidence: {
      lead: 'Chaque chiffre sur lequel repose cette conclusion, et où le regarder.',
      open: 'Ouvrir',
      none: 'La trace de ce calcul n\'a pas été conservée.',
      days: '{count} jours',
      move: 'Mouvement de l\'indicateur',
      materials: 'Références touchées',
      annualSpend: 'Achats annuels exposés',
      window: 'Fenêtre mesurée',
      confidence: 'Confiance du calcul',
      source: 'Source du chiffre',
      unconfirmed: 'Liens non confirmés',
      noData: 'Références sans consommation ni achats',
    },

    simulate: {
      title: 'Simuler {name}',
      lead: 'Rien n\'est enregistré. C\'est une question, et les questions ne vont pas dans la liste des impacts.',
      custom: 'Un autre pourcentage',
      verdict: 'Si {name} {change}, l\'année coûterait {amount} {direction}.',
      more: 'de plus',
      less: 'de moins',
      exposure: 'Achats annuels exposés',
      annualCost: 'Effet sur l\'année',
      references: 'Références touchées',
      projected: 'Prix résultant',
      unconfirmed: '{count} liens non confirmés',
      noData: '{count} références sans consommation ni achats',
      colReference: 'Référence',
      colShare: 'Part',
      colSpend: 'Achats annuels',
      colDelta: 'Différence',
      suppliers: 'Avec qui se tient la conversation',
      noLinks: 'Cet indicateur n\'est relié à aucune de vos références.',
      noLinksHint: 'Sans liens il n\'y a rien à multiplier. La réponse est un lien, pas un nombre plus grand.',
      close: 'Fermer',
    },

    compare: {
      title: 'Marché et entreprise',
      subtitle: 'Ce qu\'a fait le secteur, à côté de ce que vous avez fait',
      market: 'Marché',
      company: 'Entreprise',
      chart: 'Ouvrir',
      notLinked: 'Aucun chiffre interne associé',
      link: 'Associer',
      empty: 'Rien à comparer pour l\'instant',
      emptyHint: 'Reliez un indicateur à l\'un de vos chiffres internes depuis sa fiche.',
      noInside: 'Pas encore de chiffres internes',
      noInsideBody: 'La colonne de droite se remplit avec ce que rapportent Facturation, Devis et Achats. Sans ces modules il n\'y a rien à comparer.',
      pairTitle: '{indicator} et {metric}',
      correlation: 'Corrélation {strength} (r = {r}).',
      lag: 'Le décalage qui la renforce le plus est de {months} mois.',
      notCausation: 'Que deux séries bougent ensemble ne veut pas dire que l\'une cause l\'autre.',
      tooFew: 'Il n\'y a que {count} mois comparables ; il en faut {min} pour que le chiffre veuille dire quelque chose.',
      noCorrelation: 'Pas assez de mois en commun pour calculer quoi que ce soit.',
    },

    suppliers: {
      title: 'Fournisseurs et marché',
      subtitle: 'Comment a bougé ce que vous payez vraiment',
      method: 'Compare le prix moyen pondéré de chaque référence sur les deux moitiés des {days} derniers jours.',
      window90: 'Trois mois',
      window180: 'Six mois',
      window365: 'Un an',
      window730: 'Deux ans',
      colSupplier: 'Fournisseur et référence',
      colBefore: 'Première moitié',
      colAfter: 'Seconde moitié',
      colChange: 'Variation',
      colSpend: 'Achats',
      tooFew: 'Un seul achat',
      empty: 'Pas encore d\'achats à comparer',
      emptyHint: 'Chaque commande d\'achat reçue ajoute des lignes ici.',
      noPurchasing: 'Achats n\'est pas installé',
      noPurchasingBody: 'Ces chiffres viennent des commandes d\'achat reçues. Sans ce module, aucune ligne n\'arrive.',
      caveat: 'Seules les lignes de commandes reçues comptent. Une référence achetée une seule fois dans la fenêtre n\'a pas de pourcentage, et ce n\'est pas la même chose que d\'avoir tenu ses prix.',
    },

    reports: {
      title: 'Rapports',
      subtitle: 'Ce que publie le secteur, lu et comparable',
      file: 'Classer un rapport',
      filed: 'Rapport classé',
      searchPlaceholder: 'Titre ou source…',
      allReports: 'Tous',
      onlyRead: 'Seulement les lus',
      onlyUnread: 'Seulement les en attente',
      colTitle: 'Rapport',
      colTier: 'Niveau',
      colDate: 'Date',
      colFindings: 'Ce qui en est sorti',
      colConfidence: 'Confiance',
      figures: '{count} chiffres',
      risks: '{count} risques',
      opportunities: '{count} opportunités',
      notRead: 'Non lu',
      duplicate: 'Doublon',
      confirmations: 'confirmé par {count}',
      empty: 'Pas encore de rapports',
      emptyHint: 'Déposez le premier PDF, ou collez le texte d\'une lettre d\'information.',
      title2: 'Titre',
      titlePlaceholder: 'Rapport sur l\'industrie espagnole 2027',
      source: 'Source',
      noSource: 'Sans source',
      publishedAt: 'Date de publication',
      publishedAtHint: 'Celle du document, pas celle d\'aujourd\'hui.',
      document: 'Document',
      documentHint: 'PDF ou photographie. Jusqu\'à 25 Mo.',
      orPaste: 'Ou collez le texte',
      orPasteHint: 'Pour une lettre d\'information ou une page web qu\'on ne peut pas joindre.',
      save: 'Classer',
      analyseLater: 'Classer ne le lit pas. La lecture par l\'IA se demande ensuite, depuis la fiche du rapport.',
    },

    report: {
      openFile: 'Ouvrir le document',
      read: 'Lire avec l\'IA',
      reread: 'Relire',
      readDone: 'Rapport lu',
      notRead: 'Pas encore lu',
      notReadBody: 'Personne n\'a demandé qu\'il soit lu. Un modèle qui lit soixante pages coûte de l\'argent, cela ne se fait donc pas tout seul.',
      notReadHint: 'La lecture produit les chiffres, les risques et les opportunités, chacun avec la phrase dont il est issu.',
      summary: 'Résumé',
      figures: 'Chiffres',
      colFigure: 'Ce qu\'il mesure',
      colValue: 'Valeur',
      colPeriod: 'Période',
      accept: 'Verser dans une série',
      accepted: 'Dans la série',
      risks: 'Risques',
      opportunities: 'Opportunités',
      predictions: 'Prévisions',
      about: 'Fiche',
      source: 'Source',
      noSource: 'Sans source',
      published: 'Publié',
      filed: 'Classé',
      confidence: 'Confiance',
      corroborations: 'La même chose, dite par d\'autres',
      mentions: 'Matières premières citées',
    },

    accept: {
      title: 'Verser le chiffre dans une série',
      figure: 'Chiffre',
      period: 'Période',
      into: 'Dans quel indicateur',
      intoHint: 'Il sera enregistré comme un relevé de plus de cette série, avec le rapport comme origine.',
      pick: 'Choisissez un indicateur',
      confirm: 'Enregistrer dans la série',
      done: 'Enregistré dans la série',
    },

    topics: {
      title: 'Thèmes',
      subtitle: 'Ce que vous avez décidé de surveiller',
      new: 'Nouveau thème',
      edit: 'Modifier le thème',
      colName: 'Thème',
      colKind: 'Catégorie',
      colImportance: 'Importance',
      colContents: 'Contenu',
      colOwner: 'Responsable',
      contents: '{sources} sources · {indicators} indicateurs',
      noOwner: 'Sans responsable',
      empty: 'Pas encore de thèmes',
      emptyHint: 'Un thème regroupe sources, indicateurs et rapports. Commencez par les trois ou quatre qui vous touchent vraiment.',
      name: 'Nom',
      namePlaceholder: 'Acier, Construction Espagne, Automatisation…',
      description: 'Description',
      kind: 'Catégorie',
      importance: 'Importance',
      owner: 'Responsable',
      ownerHint: 'Un thème sans responsable est un thème que personne ne met à jour.',
      archive: 'Archiver',
      restore: 'Remettre dans les listes',
      restored: 'Thème remis dans les listes',
      showArchived: 'Afficher les archivés',
      archiveConfirm: 'Archiver ce thème ?',
      archiveConfirmHint: 'Ce qui en dépendait reste où il est et réapparaît si vous le récupérez.',
    },

    sources: {
      title: 'Sources',
      subtitle: 'D\'où sortent les chiffres, et de qui est la parole',
      new: 'Nouvelle source',
      edit: 'Modifier la source',
      tiersTitle: 'Ce que veut dire chaque niveau',
      searchPlaceholder: 'Nom ou adresse…',
      allTiers: 'Tous les niveaux',
      colName: 'Source',
      colTier: 'Niveau',
      colKind: 'Type',
      colChecked: 'Dernière revue',
      overdue: '{count} jours',
      foundSomething: 'Il y avait quelque chose',
      nothingNew: 'Rien de neuf',
      empty: 'Pas encore de sources',
      emptyHint: 'Commencez par les trois ou quatre que vous lisez déjà chaque mois.',
      name: 'Nom',
      namePlaceholder: 'Institut statistique · indice des prix industriels',
      url: 'Adresse',
      urlPlaceholder: 'https://…',
      kind: 'Type',
      tier: 'Niveau de fiabilité',
      frequency: 'Tous les combien de jours la revoir',
      frequencyHint: 'Zéro veut dire « quand quelque chose arrive » : une lettre d\'information n\'a pas de calendrier.',
      country: 'Pays',
      countryPlaceholder: 'ES',
      notes: 'Notes',
      archive: 'Archiver',
      restore: 'Remettre dans les listes',
      restored: 'Source remise dans les listes',
      showArchived: 'Afficher les archivés',
      archiveConfirm: 'Archiver cette source ?',
      archiveConfirmHint: 'Les indicateurs et les rapports qui la citent continuent de la citer.',
    },

    alerts: {
      title: 'Alertes',
      subtitle: 'Ce qui mérite d\'interrompre quelqu\'un',
      new: 'Nouvelle alerte',
      edit: 'Modifier l\'alerte',
      quietTitle: 'Comment le bruit est évité',
      quietBody: 'Une règle prévient UNE fois par mouvement, pas une fois par nuit. Ensuite elle se tait le nombre de jours que vous lui dites, même sur un autre sujet : vingt avis pour la même chose sont vingt avis que personne ne lit.',
      colName: 'Alerte',
      colKind: 'Surveille',
      colWho: 'Prévient',
      colLast: 'Dernier avis',
      colState: 'État',
      neverFired: 'Jamais déclenchée',
      on: 'Active',
      off: 'Arrêtée',
      empty: 'Pas encore d\'alertes',
      emptyHint: 'Sans alertes le module fonctionne quand même : il faut venir regarder.',
      name: 'Nom',
      namePlaceholder: 'Le cuivre monte de plus de 5 %',
      kind: 'Ce qu\'elle surveille',
      indicator: 'Indicateur',
      indicatorHint: 'Vide les surveille tous.',
      indicatorSupplierHint: 'L\'indice auquel le fournisseur est comparé. Il en faut un.',
      anyIndicator: 'N\'importe lequel',
      thresholdPct: 'À partir de quel pourcentage',
      thresholdEur: 'À partir de combien d\'euros par an',
      window: 'Sur combien de jours',
      severity: 'Gravité',
      quiet: 'Jours de silence',
      quietHint: 'Après avoir prévenu, elle se tait pendant ce temps.',
      who: 'Quels rôles elle prévient',
      whoHint: 'Des rôles, pas des personnes : une alerte adressée à quelqu\'un cesse de fonctionner la semaine de son départ.',
      whoPlaceholder: 'admin, manager',
      active: 'Active',
      removeConfirm: 'Retirer cette alerte ?',
      removeConfirmHint: 'Elle cesse de prévenir. Ce qu\'elle a déjà envoyé reste dans les notifications.',
      sentence: {
        price: 'Quand un indicateur bouge de plus de {threshold} % sur {days} jours. Silence de {quiet} jours.',
        exposure: 'Quand un impact ouvert dépasse {threshold} € par an. Silence de {quiet} jours.',
        supplier: 'Quand un fournisseur monte de plus de {threshold} points au-dessus de son indice. Silence de {quiet} jours.',
        report: 'Quand un nouveau rapport arrive sur le thème, sur les {days} derniers jours. Silence de {quiet} jours.',
        trend: 'Quand un indicateur change de direction de plus de {threshold} %. Silence de {quiet} jours.',
      },
    },

    alertKinds: {
      price: 'Un prix',
      priceHint: 'Se déclenche quand un indicateur bouge plus que vous ne le dites, sur la fenêtre que vous dites.',
      exposure: 'Ce que cela coûte',
      exposureHint: 'Se déclenche sur l\'argent, pas sur le pourcentage : 2 % sur votre achat principal, c\'est plus que 12 % sur quelque chose acheté deux fois par an.',
      supplier: 'Un fournisseur',
      supplierHint: 'Se déclenche quand un fournisseur monte au-dessus de l\'indice auquel on le compare. Cet indice doit être relié.',
      report: 'Un nouveau rapport',
      reportHint: 'Se déclenche quand quelque chose de nouveau paraît sur un thème.',
      trend: 'Un changement de tendance',
      trendHint: 'Se déclenche quand le mois et l\'année cessent d\'aller dans le même sens.',
    },

    decisions: {
      title: 'Décisions',
      subtitle: 'Ce qui a été décidé, et si cela a marché',
      new: 'Enregistrer une décision',
      allKinds: 'Toutes',
      onlyPending: 'Seulement celles à évaluer',
      colWhat: 'Décision',
      colKind: 'Type',
      colWhen: 'Date',
      colOutcome: 'Résultat',
      reviewed: 'Évaluée',
      dueNow: 'À évaluer',
      noReview: 'Sans date de revue',
      empty: 'Pas encore de décisions',
      emptyHint: 'Quand la direction décide quelque chose à partir de ces données, notez-le ici : c\'est la seule façon de savoir plus tard si cela a marché.',
      about: 'À propos de {name} {change} · {amount} par an',
      what: 'Ce qui est décidé',
      whatPlaceholder: 'Augmenter le tarif structure de 4 %',
      kind: 'Type',
      reason: 'Pourquoi',
      reasonHint: 'Ce qu\'on savait ce jour-là. Dans un an, c\'est ce qui sera lu.',
      expected: 'Ce qu\'on attend',
      expectedHint: 'C\'est là-dessus que ce sera évalué.',
      reviewAt: 'Quand y revenir',
      reviewAtHint: 'Sans date, personne n\'y revient.',
      willClose: 'Enregistrer la décision ferme aussi l\'impact qui l\'a motivée.',
      record: 'Enregistrer',
      recorded: 'Décision enregistrée',
    },

    decisionKinds: {
      update_prices: 'Mettre à jour les tarifs',
      negotiate_supplier: 'Négocier avec le fournisseur',
      buy_ahead: 'Acheter par anticipation',
      change_material: 'Changer de matériau',
      review_quotes: 'Revoir les devis',
      hold_prices: 'Maintenir les prix',
      raise_minimum: 'Relever le stock minimum',
      hedge: 'Se couvrir',
      other: 'Autre',
    },

    decision: {
      subtitle: '{kind} · {when}',
      why: 'Pourquoi cela a été décidé',
      noReason: 'Le motif n\'a pas été écrit.',
      expected: 'Ce qui était attendu',
      outcome: 'Comment cela s\'est passé',
      noOutcome: 'Pas encore évaluée.',
      howItWent: 'Ce qui s\'est vraiment passé',
      howItWentHint: 'Avec des chiffres s\'il y en a. C\'est ce qui permet de savoir si le module sert à quelque chose.',
      recordOutcome: 'Enregistrer le résultat',
      outcomeRecorded: 'Résultat enregistré',
      basedOn: 'Sur quoi cela a été décidé',
      about: 'Fiche',
      kind: 'Type',
      decidedAt: 'Date',
      decidedBy: 'Qui',
      reviewAt: 'Revue',
      openImpact: 'Ouvrir l\'impact',
    },

    briefing: {
      title: 'Note de direction',
      subtitle: 'Ce qui s\'est passé, ce que cela coûte et quoi revoir',
      weekly: 'Note hebdomadaire',
      meeting: 'Note de réunion',
      write: 'Rédiger avec l\'IA',
      unavailable: 'La rédaction n\'est pas disponible. Les chiffres ci-dessous sont la note de toute façon.',
      forDirection: 'Pour la direction',
      situation: 'Situation',
      risks: 'Risques',
      opportunities: 'Opportunités',
      suppliers: 'Fournisseurs',
      actions: 'Quoi faire cette semaine',
      noProse: 'Sans rédaction',
      noProseBody: 'Le modèle n\'a pas pu rédiger. Les chiffres sont complets ci-dessous.',
      risksCount: 'Risques ouverts',
      opportunitiesCount: 'Opportunités',
      exposure: 'Achats exposés',
      costAtRisk: 'Surcoût annuel',
      committed: 'Engagé auprès des fournisseurs',
      commodities: 'Matières premières',
      economy: 'Économie et secteur',
      openRisks: 'Risques ouverts',
      colWhat: 'Quoi',
      colChange: 'Variation',
      colCost: 'Par an',
      colReferences: 'Références',
      gaps: 'Ce que cette note ne couvre pas',
      gapUnlinked: '{count} indicateurs ne sont reliés à rien de chez vous : ils sont surveillés, mais ne produisent aucun chiffre en euros.',
      gapStale: '{count} indicateurs n\'ont pas été mis à jour depuis un moment.',
      gapCatalogue: 'Il n\'y a pas de catalogue de matériaux en miroir : sans Stock, un mouvement de prix ne peut pas être converti en euros.',
      gapQuotes: {
        not_available: 'La marge des devis ouverts n\'y figure pas : les coûts d\'un devis non accepté ne sortent jamais du module Devis, donc celui-ci ne les connaît pas.',
        module_absent: 'La marge des devis ouverts n\'y figure pas : Devis n\'est pas installé.',
      },
    },

    chart: {
      title: 'Série',
      empty: 'Pas assez de données',
      notZeroed: 'L\'axe ne commence pas à zéro',
    },

    related: {
      material: 'Marché',
      supplier: 'Prix et marché',
    },

    dashboard: {
      risks: 'Risques de marché',
      risksHelp: 'Combien de mouvements extérieurs coûtent de l\'argent en ce moment.',
      costAtRisk: 'Surcoût annuel',
      costAtRiskHelp: 'Ce que les mouvements ouverts ajoutent au coût d\'une année, à consommation actuelle.',
      opportunities: 'Opportunités',
      opportunitiesHelp: 'Combien de mouvements extérieurs vous sont favorables : matières premières ou énergie en baisse.',
      exposure: 'Achats exposés',
      exposureHelp: 'Les achats annuels qui passent par les références touchées par quelque chose qui a bougé.',
      watched: 'Facteurs surveillés',
      watchedHelp: 'Combien d\'indicateurs sont sur le radar. Passe en ambre si l\'un d\'eux n\'a pas été mis à jour depuis un moment.',
      moved: 'Ce qui bouge',
      movedHelp: 'Les facteurs hors de leur plage habituelle, avec leur variation. Étirez la carte et il en tient davantage.',
      reports: 'Nouveaux rapports',
      reportsHelp: 'Ce qui est arrivé ces deux dernières semaines, avec le niveau de sa source.',
    },

    notifications: {
      category: 'Marchés',
      price: {
        title: 'Mouvement sur {indicator}',
        body: '{indicator} a bougé de {change} % sur {days} jours.',
      },
      trend: {
        title: 'Changement de tendance sur {indicator}',
        body: '{indicator} est à {change} % sur le mois et à {year} % sur l\'année : la direction a changé.',
      },
      exposure: {
        title: 'Surcoût dû à {indicator}',
        body: '{indicator} ajoute environ {cost} € par an, sur {materials} références.',
      },
      supplier: {
        title: '{supplier} monte au-dessus du marché',
        body: '{supplier} est {deviation} points au-dessus de {indicator}.',
      },
      report: {
        title: 'Nouveaux rapports',
        body: '{count} rapports sont arrivés. Le dernier : {title}.',
      },
      weekly: {
        title: 'Note de marché',
        body: '{risks} risques et {opportunities} opportunités. Surcoût annuel estimé : {cost} €.',
      },
    },

    jobs: {
      assess: 'Recalculer le marché et évaluer les alertes',
      briefing: 'Note hebdomadaire de marché',
    },

    assistant: {
      recordingDecision: 'Enregistrement de la décision',
    },
  },

  permissions: {
    markets: {
      read: 'Voir le marché : radar, indicateurs, rapports et sources',
      exposure: 'Voir ce que le marché nous coûte, en euros',
      write: 'Tenir à jour indicateurs, séries, liens, sources et rapports',
      decide: 'Enregistrer des décisions, clore des impacts et configurer les alertes',
    },
  },

  settings: {
    ns: {
      markets: {
        title: 'Marchés',
        subtitle: 'Ce qui compte comme beaucoup dans cette entreprise',
        watchThreshold: {
          label: 'Mouvement qui mérite un regard (%, sur 30 jours)',
          help: 'En dessous, un mouvement est du bruit et rien n\'est enregistré. Chaque indicateur peut avoir le sien ; celui-ci est celui des autres.',
        },
        alertThreshold: {
          label: 'Mouvement considéré comme important (%, sur 30 jours)',
          help: 'À partir de là le radar le peint comme un risque et relève la gravité de ce qu\'il coûte.',
        },
        impactFloor: {
          label: 'Coût annuel minimal pour enregistrer un impact (€)',
          help: 'Un mouvement qui coûte moins que cela par an est exact et n\'est pas une nouvelle. Sans ce plancher, la liste de ce qui demande attention se remplit de lignes sur lesquelles personne n\'agira.',
        },
        highCost: {
          label: 'Coût annuel qui rend un impact important (€)',
          help: 'Ce qui sépare quelque chose à surveiller de quelque chose qu\'on apporte en réunion.',
        },
        criticalCost: {
          label: 'Coût annuel qui rend un impact critique (€)',
          help: 'Au-dessus, il est marqué critique et les personnes visées par l\'alerte en sont informées.',
        },
        weeklyBriefing: {
          label: 'Envoyer la note de marché le lundi',
          help: 'Un résumé de ce qui a bougé, de ce que cela coûte et de quoi regarder. Désactivez-le si vous préférez ouvrir l\'écran vous-mêmes.',
        },
      },
    },
  },

  audit: {
    actions: {
      markets: {
        topic_created: 'Thème créé',
        topic_updated: 'Thème modifié',
        topic_archived: 'Thème archivé',
        topic_restored: 'Thème remis dans les listes',
        source_created: 'Source créée',
        source_updated: 'Source modifiée',
        source_checked: 'Source revue',
        source_archived: 'Source archivée',
        source_restored: 'Source remise dans les listes',
        indicator_created: 'Indicateur créé',
        indicator_updated: 'Indicateur modifié',
        indicator_archived: 'Indicateur archivé',
        indicator_restored: 'Indicateur remis dans les listes',
        point_recorded: 'Relevé enregistré',
        point_removed: 'Relevé retiré',
        series_imported: 'Série importée',
        link_created: 'Lien créé',
        link_updated: 'Lien modifié',
        link_removed: 'Lien retiré',
        links_suggested: 'Liens proposés par l\'IA acceptés',
        report_filed: 'Rapport classé',
        report_updated: 'Rapport modifié',
        report_archived: 'Rapport retiré',
        impact_reviewed: 'Impact revu',
        impact_dismissed: 'Impact écarté',
        alert_created: 'Alerte créée',
        alert_updated: 'Alerte modifiée',
        alert_removed: 'Alerte retirée',
        decision_recorded: 'Décision enregistrée',
        decision_updated: 'Décision modifiée',
        decision_reviewed: 'Résultat de la décision enregistré',
      },
    },
  },

  assistant: {
    openers: {
      markets: {
        'whats-changed': 'Qu\'est-ce qui a changé et pourrait nous toucher ?',
        'biggest-risk': 'Quel est en ce moment notre plus grand risque de marché ?',
        'supplier-above-market': 'Y a-t-il un fournisseur qui monte au-dessus du marché ?',
        simulate: 'Combien nous coûterait une nouvelle hausse de notre matière première principale ?',
      },
    },
  },
}
